import Contract from './Contract';
import abi from '../abi/mutant.json';

class Mutant extends Contract {
    constructor(options, address) {
        super(options, "Mutant", abi, address);
    }
}

export default Mutant;